var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1819_11194)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9014,
    height: 24.4282,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8623 3.05371H5.72498V6.10723H2.8623V3.05371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58803 0V9.16056H0V0H8.58803ZM7.15669 1.52676H1.43134V7.6338H7.15669V1.52676ZM5.72535 18.3211H2.86268V21.3746H5.72535V18.3211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58803 15.2678V24.4284H0V15.2678H8.58803ZM1.43134 16.7946V22.9016H7.15669V16.7946H1.43134ZM17.1761 3.05371H20.0387V6.10723H17.1761V3.05371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3134 0V9.16056H22.9014V0H14.3134ZM21.4701 1.52676V7.6338H15.7447V1.52676H21.4701ZM11.4507 1.52676V0H12.882V3.05352H11.4507V6.10704H10.0194V1.52676H11.4507ZM11.4507 9.16056V6.10704H12.882V9.16056H11.4507ZM8.58803 12.2141V10.6873H10.0194V9.16056H11.4507V12.2141H12.882V10.6873H20.0387V12.2141H14.3134V13.7408H10.0194V12.2141H8.58803ZM8.58803 12.2141V13.7408H2.86268V12.2141H1.43134V13.7408H0V10.6873H4.29401V12.2141H8.58803ZM22.9014 13.7408H21.4701V10.6873H22.9014V13.7408ZM21.4701 13.7408H20.0387V16.7944H22.9014V15.2676H21.4701V13.7408ZM15.7447 13.7408H18.6074V15.2676H17.1761V16.7944H15.7447V13.7408ZM18.6074 18.3211V16.7944H17.1761V18.3211H15.7447V19.8479H12.882V21.3746H17.1761V18.3211H18.6074ZM18.6074 18.3211H22.9014V19.8479H20.0387V21.3746H18.6074V18.3211ZM12.882 16.7944V18.3211H14.3134V15.2676H10.0194V16.7944H12.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 18.3213H11.4509V22.9016H17.1762V24.4283H10.0195V18.3213ZM22.9016 21.3748V24.4283H18.6076V22.9016H21.4702V21.3748H22.9016Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1819_11194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9014,
    height: 24.4282,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiQrCode);
export default __webpack_public_path__ + "static/media/bi_qr-code.1201aa7c071432fefd03adc3e43d42d1.svg";
export { ForwardRef as ReactComponent };